//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PxRolesGrid',
  data: function data() {
    return {
      key: '',
      board: {}
    };
  },
  created: function created() {},
  methods: {}
};